import React from "react";
import Typography from "@mui/material/Typography";
import Utils from "../../helper/utils";
import { useTranslation } from "react-i18next";

const PasswordTopo = () => {
  const { t } = useTranslation();

  Utils.setDocumentTitle(t("pages.password.titlePage"));

  return (
    <div className="containerTitle">
      <Typography
        variant="h5"
        fontFamily={"Co Headline Regular"}
        gutterBottom
        align="left"
        marginLeft="15px"
      >
        {t("pages.password.titlePage")}
      </Typography>
    </div>

  );
};

export default PasswordTopo;
